export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8865.84ea54d9.jpg";